import * as md from './common.data.models'

export class MyAccountDetails {
    
    primaryContact: PrimaryContact = new PrimaryContact();
    membershipInfo: MembershipInfo = new MembershipInfo();
    sections: Section[] = [];
    chapters: Chapter[] = [];
    
    addresses: Addresses = new Addresses();
    education: Education = new Education();
    
    career: Career = new Career();
    credentials: Credentials = new Credentials();
    QuestionDefinitions: any = [];
    paymentDetailsOnFile: PaymentDetails[] = [];    
    
    AccountProducts: any = [];
    SalesOrders: any = [];
    ContentSnippets: any = [];

}
 

export class Education {
    medicalschools: MedicalSchool[] = [];
    internships: Internship[] = [];
    residencies: Residency[] = [];
    fellowships: Fellowship[] = [];
}


export class Career {
    employers: PrimaryEmployer[] = [];
    emcareer: EMCareer = new EMCareer();
    military: Military = new Military();
}



export class PrimaryEmployer {
    id: any = '';
    accountcontactid: any = '';
    name: any = '';
    begindate: any = '';
    jobtitle: any = '';
    position: any = '';
    //OPTIONAL// 
    address: md.Address = new md.Address();
    metadata: md.Questionnaire = new md.Questionnaire();
}

export class Military {
    contactmilitaryid: any = '';
    branch: any = '';
    rank: any = '';
    begindate: any = '';
    enddate: any = '';
}

export class EMCareer
{
    careerstatus: any = '';
    npi: any = '';
    ama: any = '';
    aoa: any = '';
    employmentstatus : any = '';
    yearbeganem: any = '';
    primarypracticelocation: any = '';
  
}


export class Credentials {
    boardcertifications: BoardCertification[] = [];
    medicallicenses: MedicalLicense[] = [];
}


export class PrimaryContact {
    personalinfo: PersonalInfo = new PersonalInfo();
    phones: Phones = new Phones();
    email: string = '';
    username: string = '';
    acepid: string = '';
}

export class PersonalInfo {
    prefix: any = '';
    firstname: string = '';
    middlename: string = '';
    lastname: string = '';
    formalname: string = '';
    suffix: string = '';
    dob: string = '';
    gender: any = '';
    ethnicity: any = '';
    professionaldesignation: string = '';
    jobtitle: string = '';
}

export class MembershipInfo {
    membershipId: string = '';
    expirationDate: string = '';
    membershipType: string = '';
    membershipRate: string = '';
    memberSince: string = '';
    isFacep: boolean = false;
    facepSince: string = '';
    
    isAFormerMember: boolean = false;
    isUnderRenewalPeriod: boolean = false;

    BO: BillingOption = new BillingOption();
}

export class Chapter {
    name: string = '';
    chapterid: string = '';
    chaptermemberid: string = '';
    allowemail: boolean = true;
    websiteurl: string = '';
}

export class Section {
    name: string = '';
    sectionid: string = '';
    sectionmemberid: string = '';
    allowemail: boolean = true;
    allowelist: boolean = true;
    websiteurl: string = '';
}



export class Addresses {
    home: CustomerAddress = new CustomerAddress();
    hospital: CustomerAddress = new CustomerAddress();
    business: CustomerAddress = new CustomerAddress();
}

export class CustomerAddress {
    address: md.Address = new md.Address();
    addressid: string = '';
    addresstype: any = '';
    isprimary: boolean = false;

}

export class Phones {
    primaryphone: string = '';
    primaryphoneext: string = '';

    homephone: string = '';
    homephoneext: string = '';

    hospitalphone: string = '';
    hospitalphoneext: string = '';

    businessphone: string = '';
    businessphoneext: string = '';

    cellphone: string = '';

    primary: string = ''; //Home/Hospital/Business/Mobile

}


export class MedicalSchool {
    id: any = '';
    contactmedicalschoolid: any = '';
    name: any = '';
    graduationdate: any = '';

    //OPTIONAL//
    address: md.Address = new md.Address();
    metadata: md.Questionnaire = new md.Questionnaire();

}

export class Internship {
    id: any = '';
    contactresidencyid: any = '';
    name: any = '';
    graduationdate: any = '';

    //OPTIONAL//
    address: md.Address = new md.Address();
    metadata: md.Questionnaire = new md.Questionnaire();

}

export class Residency {
    id: any = '';
    contactresidencyid: any = '';
    name: any = '';
    graduationdate: any = '';
    specialtyid: any = '';

    //OPTIONAL//
    address: md.Address = new md.Address();
    metadata: md.Questionnaire = new md.Questionnaire();

}

export class Fellowship {
    id: any = '';
    contactfellowshipid: any = '';
    name: any = '';
    graduationdate: any = '';
    specialtyid: any = '';
    subspecialtyid: any = '';

    //OPTIONAL//
    address: md.Address = new md.Address();
    metadata: md.Questionnaire = new md.Questionnaire();

}

export class BoardCertification {
    id: any = '';
    contactboardcertificationid: any = ''
    name: any = '';
    certificationnumber: any = '';
    effectivedate: any = '';
    expirationdate: any = '';
    //recertificationdate: any = '';

    //OPTIONAL//
    // address: md.Address = new md.Address();  
    // metadata: md.Questionnaire = new md.Questionnaire();
}

export class MedicalLicense {
    licensetypecode: any = '';
    licensenumber: any = '';
    licensestateprovince: any = '';
    licensecountry: any = 'US';
    licensedate: any = '';
    contactmedicallicenseid: any = '';
}



export class PaymentDetails {
    ProfileId: any = '';
    PostalCode: any = '';  
    CardType: any = '';
    CCExpirationDate: any = '';
    CreditCardNumber: any = '';
    OrgCode: any = '';
    PaymentMethodId: any = '';
    
}


export class BillingOption
{
    BillingOptionId: any = '';
    PaymentMethodId: any = '';
    Acep_CCLast4Digits: any = '';
    CCExpiryDate: any = '';
    InstallmentOrRenewalDate: any = '';
    IsOnAutoRenewal: any = '';
    OnInstallments: any = '';
    PaymentType: any = '';
    ProductName: any = '';    
    PaymentStatus: any = ''; 
    PaymentMethodOrgCode: any = '';
}







